import { render } from "./KategoriSatker.vue?vue&type=template&id=728529b1"
import script from "./KategoriSatker.vue?vue&type=script&lang=js"
export * from "./KategoriSatker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__